import { getDateField, getIntegerField, getTextField } from '@lender/utils';
import { object } from 'yup';

import { prepareStringForComparison } from 'utils/data';
import {
  checkIsPendingChangeHasDifference,
  mergePendingChanges,
  normalizePendingChanges,
} from 'utils/pendingChanges';

import {
  createDefaultDocumentExpirationDateAction,
  createDocumentExpirationDateAction,
  editDocumentExpirationDateAction,
} from 'store/underwriting/actions';

import { TableCellId } from '../DocumentExpirationDates.constants';

import { fieldsPendingChangeNormalizers, formFields } from './DocumentExpirationDateForm.constants';

export const getIsFieldChangedMapByFieldName = ({ initialPendingChanges, formPendingChanges }) => {
  const mergedPendingChanges = mergePendingChanges(initialPendingChanges, formPendingChanges);

  const normalizedPendingChanges = normalizePendingChanges({
    fieldsPendingChangeNormalizers,
    pendingChanges: mergedPendingChanges,
  });

  return formFields.reduce((acc, fieldName) => {
    acc[fieldName] = checkIsPendingChangeHasDifference(normalizedPendingChanges[fieldName]);

    return acc;
  }, {});
};

export const getIsFieldDisabledByAutoLockMapByFieldName = autoLockDisabledFields =>
  formFields.reduce((acc, fieldName) => {
    acc[fieldName] = autoLockDisabledFields.includes(fieldName);

    return acc;
  }, {});

export const getOnSaveAction = ({ isNewRecord, isDefaultDocumentExpirationDateToCreate }) => {
  if (isNewRecord) {
    return createDocumentExpirationDateAction;
  }

  if (isDefaultDocumentExpirationDateToCreate) {
    return createDefaultDocumentExpirationDateAction;
  }

  return editDocumentExpirationDateAction;
};

export const getSchema = ({ busyTitles }) =>
  object().shape({
    [TableCellId.TITLE]: getTextField({ isRequired: true })
      .test(
        'should-be-unique',
        'Title should be unique',
        value =>
          !busyTitles.some(
            busyTitle =>
              prepareStringForComparison(busyTitle) === prepareStringForComparison(value),
          ),
      )
      .nullable(),
    [TableCellId.START_DATE]: getDateField({ isRequired: true }).nullable(),
    [TableCellId.EXPIRES_IN_DAYS]: getIntegerField({ isRequired: true }).min(1).nullable(),
    [TableCellId.EXPIRATION_DATE]: getTextField({ isRequired: false }).nullable(),
  });
